module.exports = __webpack_public_path__ + "static/media/Chevron-Right.37f85923.svg";